import React from 'react';
import type { IconProps } from '@atlaskit/icon';
import ArchiveBoxIcon from '@atlaskit/icon/core/archive-box';
import FormIcon from '@atlaskit/icon/core/form';
import AppIcon from '@atlaskit/icon/core/migration/app--addon';
import AttachmentsIcon from '@atlaskit/icon/core/migration/attachment';
import BoardIcon from '@atlaskit/icon/core/migration/board';
import CalendarIcon from '@atlaskit/icon/core/migration/calendar';
import ChartTrendIcon from '@atlaskit/icon/core/migration/chart-trend--graph-line';
import ComponentsIcon from '@atlaskit/icon/core/migration/component';
import DashboardIcon from '@atlaskit/icon/core/migration/dashboard--activity';
import DecisionIcon from '@atlaskit/icon/core/migration/decision--editor-decision';
import IssuesIcon from '@atlaskit/icon/core/migration/work-items--issues';
import LinkIcon from '@atlaskit/icon/core/migration/link--editor-link';
import ListBulletedIcon from '@atlaskit/icon/core/migration/list-bulleted--bullet-list';
import RoadmapIcon from '@atlaskit/icon/core/migration/roadmap';
import PageIcon from '@atlaskit/icon/core/page';
import MediaWrapLeftIcon from '@atlaskit/icon/glyph/editor/media-wrap-left';
import FileIcon from '@atlaskit/icon/glyph/file';
import type { JiraNavigationItemTypeKey } from '@atlassian/jira-relay/src/__generated__/simpleNavigationTab_businessTabs.graphql';

type Props = IconProps & {
	typeKey: JiraNavigationItemTypeKey;
};

export const TabIcon = ({ typeKey, size, ...iconProps }: Props) => {
	const migrationIconSize = size === 'small' ? 'none' : 'spacious';
	switch (typeKey) {
		case 'SUMMARY':
			return (
				<DashboardIcon
					{...iconProps}
					color="currentColor"
					spacing={migrationIconSize}
					LEGACY_size={size}
				/>
			);
		case 'BOARD':
			return (
				<BoardIcon
					{...iconProps}
					color="currentColor"
					spacing={migrationIconSize}
					LEGACY_size={size}
				/>
			);
		case 'LIST':
			return (
				<ListBulletedIcon
					{...iconProps}
					color="currentColor"
					spacing={migrationIconSize}
					LEGACY_size={size}
				/>
			);
		case 'CALENDAR':
			return (
				<CalendarIcon
					{...iconProps}
					color="currentColor"
					spacing={migrationIconSize}
					LEGACY_size={size}
				/>
			);
		case 'TIMELINE':
			return (
				<RoadmapIcon
					{...iconProps}
					color="currentColor"
					spacing={migrationIconSize}
					LEGACY_size={size}
				/>
			);
		case 'APPROVALS':
			return (
				<DecisionIcon
					{...iconProps}
					color="currentColor"
					spacing={migrationIconSize}
					LEGACY_size={size}
				/>
			);
		case 'FORMS':
			return (
				<FormIcon
					{...iconProps}
					color="currentColor"
					spacing={migrationIconSize}
					LEGACY_fallbackIcon={MediaWrapLeftIcon}
					LEGACY_size={size}
				/>
			);
		case 'PAGES':
			return (
				<PageIcon
					{...iconProps}
					color="currentColor"
					spacing={migrationIconSize}
					LEGACY_size={size}
					LEGACY_fallbackIcon={FileIcon}
				/>
			);
		case 'ATTACHMENTS':
			return (
				<AttachmentsIcon
					{...iconProps}
					color="currentColor"
					spacing={migrationIconSize}
					LEGACY_size={size}
				/>
			);
		case 'ISSUES':
			return (
				<IssuesIcon
					{...iconProps}
					color="currentColor"
					spacing={migrationIconSize}
					LEGACY_size={size}
				/>
			);
		case 'REPORTS':
			return (
				<ChartTrendIcon
					{...iconProps}
					color="currentColor"
					spacing={migrationIconSize}
					LEGACY_size={size}
				/>
			);
		case 'COMPONENTS':
			return (
				<ComponentsIcon
					{...iconProps}
					color="currentColor"
					spacing={migrationIconSize}
					LEGACY_size={size}
				/>
			);
		case 'APPS':
			return (
				<AppIcon
					{...iconProps}
					color="currentColor"
					spacing={migrationIconSize}
					LEGACY_size={size}
				/>
			);
		case 'SHORTCUTS':
			return (
				<LinkIcon
					{...iconProps}
					color="currentColor"
					spacing={migrationIconSize}
					LEGACY_size={size}
				/>
			);
		case 'ARCHIVED_ISSUES':
			return (
				<ArchiveBoxIcon
					{...iconProps}
					color="currentColor"
					spacing={migrationIconSize}
					LEGACY_size={size}
				/>
			);
		default:
			return null;
	}
};
